import toast from "izitoast";

export const ToastService = {
  info,
  destroy,
  question,
  question2,
  error,
  success,
  uploadingImage,
  instance,
  hideAt,
  warning
};

function destroy() {
  toast.destroy();
}

function hideAt(element) {
  toast.hide({}, element);
}

function info(title = "", message = "") {
  return toast.info({
    title: title,
    message: message,
    timeout: 5000,
    position: "topCenter",
    color: "dark",
    theme: "dark"
  });
}

function error(title = "", message = "") {
  return toast.error({
    title: title,
    message: message,
    position: "topCenter",
    transitionIn: "flipInX",
    transitionOut: "flipOutX",
    transitionInMobile: "fadeInUp",
    transitionOutMobile: "fadeOutDown"
  });
}

function warning(title = "", message = "") {
  return toast.warning({
    title,
    message,
    position: "topLeft",
    transitionIn: "flipInX",
    transitionOut: "flipOutX",
    transitionInMobile: "fadeInUp",
    transitionOutMobile: "fadeOutDown"
  });
}

function question(
  title = "",
  message = "",
  onYes = null,
  onNo = null,
  target = ""
) {
  return toast.question({
    timeout: false,
    close: false,
    overlay: true,
    displayMode: "once",
    target: target,
    id: "question",
    color: "dark",
    theme: "dark",
    zindex: 9999,
    title,
    message,
    position: "bottomCenter",
    buttons: [
      ["<button><b>Si</b></button>", onYes, true],
      ["<button>No</button>", onNo]
    ],
    onClosing: function(instance, toast, closedBy) {},
    onClosed: function(instance, toast, closedBy) {}
  });
}

function question2(
  title = "",
  message = "",
  buttons = [],
  target = ""
) {
  return toast.question({
    timeout: false,
    close: false,
    overlay: true,
    displayMode: "once",
    target: target,
    id: "question",
    color: "dark",
    theme: "dark",
    zindex: 9999,
    title,
    message,
    position: "bottomCenter",
    buttons,
    onClosing: function(instance, toast, closedBy) {},
    onClosed: function(instance, toast, closedBy) {}
  });
}

function success(message = "") {
  return toast.success({
    title: "OK",
    message: message,
    position: "topCenter"
  });
}

function uploadingImage() {
  return toast.show({
    class: "toast-up-file",
    theme: "dark",
    position: "bottomRight",
    progressBar: false,
    message: "Subiendo archivo",
    timeout: false,
    iconUrl: "static/img/uploading.gif",
    backgroundColor: "#1E6FCB",
    displayMode: 2
  });
}

function instance() {
  return toast;
}



// WEBPACK FOOTER //
// ./src/services/toast.service.js